"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTemplate = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const PageTemplateNav_1 = __importDefault(require("./PageTemplateNav"));
const PageTemplateCardOver_1 = __importDefault(require("./PageTemplateCardOver"));
const PageTemplateHeader_1 = __importDefault(require("./PageTemplateHeader"));
const search_1 = require("../search");
const StyledPageTemplate = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 30px;
  overflow: hidden;
  background: linear-gradient(
    to bottom,
    ${props => {
    var _a;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.headerBackground) ||
        props.theme.palette.primary.dark;
}},
    ${props => {
    var _a;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.headerBackground) ||
        props.theme.palette.primary.dark;
}}
      117px,
    ${props => {
    var _a;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.background) ||
        props.theme.palette.secondary.light;
}}
      0%
  );
  .page-template-header {
    height: 117px;
    overflow: hidden;
  }
  &.page-template-tabs {
    background: linear-gradient(
      to bottom,
      ${props => {
    var _a;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.headerBackground) ||
        props.theme.palette.primary.dark;
}},
      ${props => {
    var _a;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.headerBackground) ||
        props.theme.palette.primary.dark;
}}
        117px,
      ${props => {
    var _a;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.background) ||
        props.theme.palette.secondary.light;
}}
        0%
    );
  }
  &.card-over {
    background: linear-gradient(
      to bottom,
      ${props => {
    var _a;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.headerBackground) ||
        props.theme.palette.primary.dark;
}},
      ${props => {
    var _a;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.headerBackground) ||
        props.theme.palette.primary.dark;
}}
        183px,
      ${props => {
    var _a;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.background) ||
        props.theme.palette.secondary.light;
}}
        0%
    );
    .page-template-header {
      height: 126px;
      overflow: hidden;
    }
  }

  .page-template-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    /* Tables in the Card Over templte should scroll in place */
    .MuiTableContainer-root {
      flex: 1;
      overflow: auto;
    }
  }
  ${props => props.theme.breakpoints.down('sm')} {
    padding: 0 10px;
    &.search .page-template-header {
      padding: 24px 0 0 0;
    }
    .page-template-nav {
      /* margin-top: 42px; */
    }
  }
`;
const PageTemplate = props => {
    const { children } = props;
    let { className = '' } = props;
    className += ' page-template';
    react_1.default.Children.map(children, child => {
        // check if CardOverNav exists
        const reactElement = child;
        if (reactElement) {
            if (reactElement.type === PageTemplateHeader_1.default) {
                react_1.default.Children.map(reactElement.props.children, (child) => {
                    if ((child === null || child === void 0 ? void 0 : child.type) === search_1.SearchBox) {
                        className += ' search';
                    }
                });
            }
            else if (reactElement.type === PageTemplateNav_1.default) {
                className += ' page-template-tabs';
            }
            else if (reactElement.type === PageTemplateCardOver_1.default) {
                className += ' card-over';
            }
        }
    });
    return (react_1.default.createElement(StyledPageTemplate, { className: className }, children));
};
exports.PageTemplate = PageTemplate;
exports.default = exports.PageTemplate;
//# sourceMappingURL=PageTemplate.js.map